var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../../libs/gojs/release/go';
import * as _ from 'lodash';
import { DiagramConsts } from '../../diagram-consts';
import { NodeElement } from '../base/node-element';
import { CalibrationGoModelToDataUtil } from '../../../element-setting/shared/calibration-mark/calibration-go-model-to-data-util';
import { RotationDirectionType } from '../../../../../shared/dynamic-conduct-model/rotation/rotation-direction-type';
import { DataType } from '../../../core/variable/data-type';
var $ = go.GraphObject.make;
var RingGraphElement = /** @class */ (function (_super) {
    __extends(RingGraphElement, _super);
    function RingGraphElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RingGraphElement.prototype.compile = function (model, data, svg) {
        model['version'] = 4;
        var variable;
        if (data.variableVersion) {
            variable = { name: data.variableName, variableVersion: data.variableVersion };
            model['variableId'] = {
                variableName: variable
            };
        }
        else {
            variable = { name: data.variableName, groupName: data.variableGroupName };
            model['variableId'] = {
                dataSourceCode: data.dataSourceCode,
                variableName: variable
            };
        }
        model['size'] = this.sizeService.parse(data.size);
        model['location'] = go.Point.parse(data.loc);
        var arc = {
            startAngle: data.startAngle,
            endAngle: data.isFullRing ? data.startAngle : data.endAngle
        };
        model['arc'] = arc;
        model['scale'] = data.radiusPercentage;
        model['min'] = data.minCalibration;
        model['max'] = data.maxCalibration;
        model['direction'] = data.rotationDirection;
        model['borderStroke'] = data.borderColor;
        model['backgroundFill'] = data.backgroundColor;
        model['barFill'] = data.barColor;
        model['enableAlarmRange'] = data.useAlarmLimit;
        if (data.useAlarmLimit) {
            model['alarmRange'] = {
                lower: data.lowerLimit,
                upper: data.upperLimit,
                lowerFill: data.lowerLimitColor,
                upperFill: data.upperLimitColor
            };
        }
        model['showPercentage'] = data.showPercentage;
        if (data.showPercentage) {
            var percentageFont = new CalibrationGoModelToDataUtil(data).toViewData().percentageFont;
            var font = {
                isUnderline: percentageFont.isUnderline,
                isBold: percentageFont.isBold,
                isItalic: percentageFont.isItalic,
                fontSize: percentageFont.fontSize,
                color: percentageFont.color,
                textAlign: percentageFont.textAlign
            };
            model['percentageFont'] = font;
        }
        // 注意！调整绘制顺序要同步调整这里。
        svg.children().eq(8).attr('d', '').attr('data-id', 'barArc');
        if (data.showPercentage) {
            svg.children('text').text('').attr('data-id', 'pText');
        }
    };
    RingGraphElement.prototype.getPaletteTemplate = function () {
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10, source: '/assets/common/images/configure/elements/ring-small.png' }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    RingGraphElement.prototype.getDiagramTemplate = function () {
        var _this = this;
        return $(go.Node, 'Spot', {
            resizable: true, locationSpot: go.Spot.TopLeft,
            selectionAdorned: true,
            resizeObjectName: 'Part_BG',
            /* 位置以环所在的矩形为准。不包含刻度的。 */
            locationObjectName: 'Part_BG',
            selectionObjectName: 'Part_BG',
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), $(go.Shape, 'Square', {
            name: 'Part_BG',
            fill: 'transparent', stroke: 'transparent'
        }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify)), $(go.Shape, { fill: '#eeeeee', stroke: '#000000', strokeWidth: 1, name: 'BGRing' }, new go.Binding('stroke', 'borderColor'), new go.Binding('fill', 'backgroundColor'), new go.Binding('geometry', '', function (model) { return _this.makeBgSector(model); })), $(go.Shape, { fill: '#3695ff', strokeWidth: 0 }, new go.Binding('fill', 'barColor'), new go.Binding('geometry', '', function (model) { return _this.makeBarSector(model); })), this.makeScale(), this.makePercentage());
    };
    RingGraphElement.prototype.makeScale = function () {
        var _this = this;
        return $(go.Panel, 'Graduated', {
            stretch: go.GraphObject.None,
            alignmentFocus: go.Spot.Center,
            alignmentFocusName: 'Scale_ARC'
        }, new go.Binding('visible', 'showScale'), new go.Binding('graduatedMax', 'maxCalibration'), new go.Binding('graduatedMin', 'minCalibration'), new go.Binding('graduatedTickBase', 'minCalibration'), new go.Binding('graduatedTickUnit', '', function (model) {
            return (model.maxCalibration - model.minCalibration) / model.masterDivisionNumber / model.subDivisionNumber;
        }), $(go.Shape, { name: 'Scale_ARC', fill: 'transparent' }, new go.Binding('geometry', '', function (model) { return _this.makeScaleGeometry(model); })), $(go.Shape, {
            geometryString: 'M0 0 V8', stroke: 'black',
            strokeWidth: 1, alignmentFocus: go.Spot.Bottom
        }, new go.Binding('stroke', 'calibrationColor'), new go.Binding('alignmentFocus', 'rotationDirection', function (direction) {
            return Number(direction) === RotationDirectionType.ClockWise ? go.Spot.Bottom : go.Spot.Top;
        })), $(go.Shape, {
            geometryString: 'M0 0 V16', stroke: 'black',
            strokeWidth: 2, alignmentFocus: go.Spot.Bottom
        }, new go.Binding('interval', 'subDivisionNumber'), new go.Binding('stroke', 'calibrationColor'), new go.Binding('alignmentFocus', 'rotationDirection', function (direction) {
            return Number(direction) === RotationDirectionType.ClockWise ? go.Spot.Bottom : go.Spot.Top;
        })), $(go.TextBlock, {
            font: '14pt sans-serif', stroke: 'black',
            alignmentFocus: go.Spot.Center,
            segmentOffset: new go.Point(0, -30)
        }, new go.Binding('graduatedFunction', '', function (data) {
            return function (value) {
                if (data.isFullRing && value === data.maxCalibration) {
                    return '';
                }
                if (data.integerDigits) {
                    if (data.fractionDigits > 0) {
                        if (data.variableDataType && +data.variableDataType === DataType.Float) {
                            return value.toFixed(data.fractionDigits);
                        }
                        else {
                            return (value / Math.pow(10, data.fractionDigits)).toFixed(data.fractionDigits);
                        }
                    }
                    return value.toFixed(0);
                }
            };
        }), new go.Binding('interval', 'subDivisionNumber'), new go.Binding('font', 'calibrationDigitFontStyle'), new go.Binding('stroke', 'calibrationDigitColor'), new go.Binding('isUnderline', 'calibrationDigitIsUnderline'), new go.Binding('visible', '', this.showCalibrationDigit), new go.Binding('segmentOffset', 'rotationDirection', function (direction) {
            return Number(direction) === RotationDirectionType.ClockWise ? new go.Point(0, -30) : new go.Point(0, 30);
        })));
    };
    RingGraphElement.prototype.makePercentage = function () {
        return $(go.TextBlock, {
            editable: false, text: '33%',
            visible: false, segmentOrientation: go.Link.None,
            alignment: go.Spot.Center,
        }, new go.Binding('visible', 'showPercentage'), new go.Binding('font', 'percentageFontStyle'), new go.Binding('stroke', 'percentageColor'), new go.Binding('isUnderline', 'percentageIsUnderline'));
    };
    RingGraphElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.ringGraphKey;
    };
    RingGraphElement.prototype.makeBgSector = function (model) {
        var startAngle = this.adjustAngle(model.startAngle);
        var endAngle = this.adjustAngle(model.endAngle);
        var sweepAngle = model.isFullRing ? 360 : (startAngle < endAngle ? (endAngle - startAngle) : (endAngle + 360 - startAngle));
        var size = go.Size.parse(model.size);
        var outer = size.width / 2.0;
        var inner = outer * (model.radiusPercentage / 100.0);
        return this.makeSectorGeometry(startAngle, sweepAngle, outer, inner);
    };
    RingGraphElement.prototype.makeBarSector = function (model) {
        var rawStartAngle = this.adjustAngle(model.startAngle);
        var rawEndAngle = this.adjustAngle(model.endAngle);
        var rawSweepAngle = model.isFullRing ? 360 :
            (rawStartAngle < rawEndAngle ? (rawEndAngle - rawStartAngle) : (rawEndAngle + 360 - rawStartAngle));
        var startAngle = 0;
        var sweepAngle = 0;
        switch (Number(model.rotationDirection)) {
            case RotationDirectionType.ClockWise:
                startAngle = rawStartAngle;
                sweepAngle = rawSweepAngle / 3.0;
                break;
            case RotationDirectionType.ReverseClockWise:
                startAngle = rawSweepAngle * (2.0 / 3.0) + rawStartAngle;
                sweepAngle = rawSweepAngle / 3.0;
                break;
        }
        var size = go.Size.parse(model.size);
        var outer = size.width / 2.0;
        var inner = outer * (model.radiusPercentage / 100.0);
        return this.makeSectorGeometry(startAngle, sweepAngle, outer, inner);
    };
    RingGraphElement.prototype.makeScaleGeometry = function (model) {
        var startAngle = this.adjustAngle(model.startAngle);
        var endAngle = this.adjustAngle(model.endAngle);
        var sweepAngle = model.isFullRing ? 360 : (startAngle < endAngle ? (endAngle - startAngle) : (endAngle + 360 - startAngle));
        var size = go.Size.parse(model.size);
        var outer = size.width / 2.0;
        switch (Number(model.rotationDirection)) {
            case RotationDirectionType.ClockWise:
                var p = new go.Point(outer, 0).rotate(startAngle);
                return new go.Geometry()
                    .add(new go.PathFigure(p.x + outer, p.y + outer) // start at outer corner, go clockwise
                    .add(new go.PathSegment(go.PathSegment.Arc, startAngle, sweepAngle, outer, outer, outer, outer)))
                    .add(new go.PathFigure(0, 0)) // make sure the Geometry always includes the whole circle
                    .add(new go.PathFigure(2 * outer, 2 * outer)); // even if only a small sector is "lit"
            case RotationDirectionType.ReverseClockWise:
                var pr = new go.Point(outer, 0).rotate(startAngle + sweepAngle);
                return new go.Geometry()
                    .add(new go.PathFigure(pr.x + outer, pr.y + outer) // start at outer corner, go clockwise
                    .add(new go.PathSegment(go.PathSegment.Arc, startAngle + sweepAngle, -sweepAngle, outer, outer, outer, outer)))
                    .add(new go.PathFigure(0, 0)) // make sure the Geometry always includes the whole circle
                    .add(new go.PathFigure(2 * outer, 2 * outer)); // even if only a small sector is "lit"
            default:
                return undefined;
        }
    };
    RingGraphElement.prototype.makeSectorGeometry = function (startAngle, sweepAngle, outer, inner) {
        var p = new go.Point(outer, 0).rotate(startAngle);
        var q = new go.Point(inner, 0).rotate(startAngle + sweepAngle);
        return new go.Geometry()
            .add(new go.PathFigure(p.x + outer, p.y + outer) // start at outer corner, go clockwise
            .add(new go.PathSegment(go.PathSegment.Arc, startAngle, sweepAngle, outer, outer, outer, outer))
            .add(new go.PathSegment(go.PathSegment.Line, q.x + outer, q.y + outer)) // to opposite inner corner, then anticlockwise
            .add(new go.PathSegment(go.PathSegment.Arc, startAngle + sweepAngle, -sweepAngle, outer, outer, inner, inner).close()))
            .add(new go.PathFigure(0, 0)) // make sure the Geometry always includes the whole circle
            .add(new go.PathFigure(2 * outer, 2 * outer)); // even if only a small sector is "lit"
    };
    RingGraphElement.prototype.adjustAngle = function (angle) {
        if (!_.isFinite(angle)) {
            return 0;
        }
        if (angle < 0) {
            return 0;
        }
        if (angle > 360) {
            return 0;
        }
        return angle;
    };
    RingGraphElement.prototype.showCalibrationDigit = function (data) {
        return data.showScale && data.showCalibrationDigit;
    };
    return RingGraphElement;
}(NodeElement));
export { RingGraphElement };
